import type { AxiosRequestConfig } from 'axios'
import { createAxios } from './base'
import { CONTENT_TYPE, UPLOAD_DEFAULT_FILENAME } from './constant'
import { getEnv } from '@/utils'
/**
 * 普通请求
 */
export const http = createAxios()
export const mockHttp = createAxios({
  reqConfig: {
    baseURL: 'https://m1.apifoxmock.com/m1/7560913-7318130-default'
  }
})
export interface HttpUploadParams {
  // Other parameters
  data?: BD.Recordable
  // File parameter interface field name
  name?: string
  // file name
  file: File | Blob
}
/**
 * 文件上传
 */
export function upload<T = any>(url: string, params: HttpUploadParams, config: AxiosRequestConfig = {}) {
  const req = createAxios({
    header: {
      'Content-Type': CONTENT_TYPE.FORM_DATA
    },
    reqConfig: {
      timeout: getEnv('VITE_BD_API_UPLOAD_TIMEOUT')
    }
  })
  const formData = new window.FormData()
  const _fileName = params.name || UPLOAD_DEFAULT_FILENAME
  formData.append(_fileName, params.file)
  if (params.data) {
    Object.keys(params.data).forEach(key => {
      const value = params.data![key]
      if (value === undefined || value === null) return
      if (Array.isArray(value)) {
        value.forEach(item => {
          formData.append(`${key}[]`, item)
        })
        return
      }
      formData.append(key, params.data![key])
    })
  }
  return req.post<T>(url, formData, config)
}

/**
 * 二进制文件
 */
export const blob = createAxios({
  reqConfig: {
    responseType: 'blob'
  }
})
